import React, { useState } from "react";
import { useSelector } from "react-redux";
import ArchChooseFile from "./ArchChooseFile.jsx";
import ArchChooseLanguage from "./ArchChooseLanguage.jsx";
import ArchConfiguration from "./ArchConfiguration.jsx";
import ArchFolderStructure from "./ArchFolderStructure.jsx";
import "./ArchitectureConversion.scss"
import ArchSummary from "./ArchSummary.jsx";
import ArchResult from "./ArchResult.jsx"

function ArchitectureConversion() {
  const currentStep = useSelector((state) => state.architectureConversion.currentStep);
  const [sourceFiles, setSourceFiles] = useState([]);
  const [targetFiles, setTargetFiles] = useState([]);
  const [gitRepoUrl, setGitRepoUrl] = useState("");

  return (
    <>
      {currentStep === 1 && <ArchChooseFile setSourceFiles={setSourceFiles} sourceFiles={sourceFiles} setGitRepoUrl={setGitRepoUrl} />}
      {currentStep === 2 && <ArchFolderStructure targetFiles={targetFiles} sourceFiles={sourceFiles} setTargetFiles={setTargetFiles} gitRepoUrl={gitRepoUrl} />}
      {currentStep === 3 && <ArchChooseLanguage sourceFiles={sourceFiles} />}
      {currentStep === 4 && <ArchConfiguration />}
      {currentStep === 5 && <ArchSummary />}
      {currentStep === 6 && <ArchResult />}
    </>
  );
}

export default ArchitectureConversion;